import React, { useEffect } from "react";
import { Typography, Icon } from "@plum-xoxo/admin-dsm";
import styled from "styled-components";
import WhomToSend from "../WhomToSend";

const ActiveIcon = styled.div`
  background-color: ${(props) => props.theme.palette.primary.c02};
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 4px solid ${(props) => props.theme.palette.primary.c01};
  margin: 2px;
`;

const PendingIcon = styled.div`
  background-color: ${(props) => props.theme.palette.primary.c01};
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 4px solid transparent;
  margin: 2px;
`;

const CompleteIcon = () => (
  <Icon
    color="primary"
    shade="c02"
    size="20"
    iconName="PlumCheckbox"
    className="p-0 m-0"
  />
);
const StyledDivGap = styled.div`
  gap: 16px;
`;

const RewardsStepper = ({
  activeTab,
  setActiveTab,
  recipientType,
  recipientData,
  setActiveSetting,
  isFileUploaded,
  rewardType,
  linksQty,
  selectedSite,
  status,
  kybStatus,
}) => {
  useEffect(() => {
    if (kybStatus !== 2) setActiveTab(-2);
  }, []);

  const handleActiveSetting = (index) => {
    if (rewardType === 3 && !selectedSite?.campaignId) return;

    setActiveTab(1);
    setActiveSetting(index);
  };

  return (
    <>
      <div className="mt-60">
        {kybStatus !== 2 && (
          <StyledDivGap className="d-flex mb-24">
            {activeTab === -2 ? <ActiveIcon /> : <PendingIcon />}
            <Typography.LabelText
              className="cursor-pointer"
              onClick={() => setActiveTab(-2)}
            >
              {"Get Started"}
            </Typography.LabelText>
          </StyledDivGap>
        )}
        {rewardType === 3 && (
          <StyledDivGap className="d-flex mb-24">
            {activeTab === -1 ? (
              <ActiveIcon />
            ) : activeTab > -1 && selectedSite?.campaignId ? (
              <CompleteIcon />
            ) : (
              <PendingIcon />
            )}
            <div>
              <Typography.LabelText
                onClick={() => setActiveTab(-1)}
                className="cursor-pointer mb-2"
              >
                Campaign
              </Typography.LabelText>
            </div>
          </StyledDivGap>
        )}
        <StyledDivGap className="d-flex cursor-pointer">
          {activeTab === 0 ? (
            <ActiveIcon />
          ) : activeTab > 0 &&
            (recipientData.length > 0 || isFileUploaded || linksQty > 0) ? (
            <CompleteIcon />
          ) : (
            <PendingIcon />
          )}
          <div>
            <Typography.LabelText
              onClick={() => {
                if (rewardType === 3 && !selectedSite?.campaignId) return;
                setActiveTab(0);
              }}
              className={`${
                rewardType === 3 && !selectedSite?.campaignId
                  ? ""
                  : "cursor-pointer"
              }  d-flex align-items-center mb-2`}
            >
              Recipients{" "}
              {(status === "VALIDATION_FAILURE" || status === "FAILURE") && (
                <Icon
                  color="orange"
                  iconName="Warning"
                  size="s"
                  shade="c02"
                  className="ml-4"
                />
              )}
            </Typography.LabelText>
            <Typography.BodySmall color="dark" shade="c200" className="mb-0">
              {recipientType === 0 && isFileUploaded
                ? "File Uploaded"
                : recipientData.length > 0 ||
                  activeTab === 1 ||
                  activeTab === -1 ||
                  activeTab === -2 ||
                  (recipientType == 2 && linksQty > 0)
                ? `${
                    recipientType === 2 ? linksQty : recipientData.length
                  } added`
                : "Adding..."}
            </Typography.BodySmall>
          </div>
        </StyledDivGap>
        <StyledDivGap className="d-flex mt-24">
          {activeTab === 1 ? (
            <ActiveIcon />
          ) : activeTab > 1 ? (
            <CompleteIcon />
          ) : (
            <PendingIcon />
          )}
          <StyledDivGap
            className={`d-flex flex-column ${
              rewardType === 3 && !selectedSite?.campaignId
                ? ""
                : "cursor-pointer"
            }`}
          >
            <Typography.LabelText
              onClick={() => {
                if (rewardType === 3 && !selectedSite?.campaignId) return;
                setActiveTab(1);
              }}
              component="div"
              className="d-flex align-items-center cursor-pointer"
            >
              Additional Settings{" "}
              {/* <Icon
                iconName="DownArrow"
                color="dark"
                shade="c200"
                className="ml-4"
              /> */}
            </Typography.LabelText>
            {(rewardType === 1 || rewardType === 2) && (
              <Typography.BodySmall
                onClick={() => handleActiveSetting(2)}
                color="dark"
                shade="c200"
                className="mb-0"
              >
                Campaign
              </Typography.BodySmall>
            )}
            {!(rewardType === 3 && recipientType === 2) && (
              <Typography.BodySmall
                onClick={() => handleActiveSetting(1)}
                color="dark"
                shade="c200"
                className="mb-0"
              >
                Communications
              </Typography.BodySmall>
            )}
            {(rewardType === 2 || rewardType === 3) && (
              <Typography.BodySmall
                onClick={() => handleActiveSetting(3)}
                color="dark"
                shade="c200"
                className="mb-0"
              >
                Expiry
              </Typography.BodySmall>
            )}
          </StyledDivGap>
        </StyledDivGap>
        <hr className="mt-40" />
        <WhomToSend reward_type={rewardType} />
      </div>
    </>
  );
};

export default RewardsStepper;
